import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {RootState} from '../../app/rootReducer'
import {
    fetchAllDealers,
    fetchMyDealerBranches,
    getDealerName,
} from '../../app/thunk'
import {Dealer} from '../../types/dealer'
import {RequestStatus} from '../../shared/variables'

export const dealerDataSlice = createSlice({
    name: 'dealerData',
    initialState: {
        allDealers: [],
        allDealersStatus: RequestStatus.IDLE,
        dealerBranches: [],
        dealerCode: '',
        dealerName: '',
    },
    reducers: {
        setAllDealers(state: RootState, action: PayloadAction<Dealer[]>): void {
            state.allDealers = action.payload
        },
        setDealerBranches(
            state: RootState,
            action: PayloadAction<Dealer[] | null>
        ): void {
            state.dealerBranches = action.payload
        },
        setDealerCode(state: RootState, action: PayloadAction<string>): void {
            state.dealerCode = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDealerName.fulfilled, (state: RootState, action) => {
                state.dealerName = action.payload
            })
            .addCase(fetchAllDealers.pending, (state: RootState) => {
                state.allDealersStatus = RequestStatus.LOADING
            })
            .addCase(fetchAllDealers.fulfilled, (state: RootState, action) => {
                state.allDealers = action.payload
                state.allDealersStatus = RequestStatus.SUCCEEDED
            })
            .addCase(fetchAllDealers.rejected, (state: RootState) => {
                state.allDealersStatus = RequestStatus.FAILED
            })
            .addCase(
                fetchMyDealerBranches.fulfilled,
                (state: RootState, action) => {
                    state.dealerBranches = action.payload
                }
            )
    },
})

export const {setDealerCode, setDealerBranches} = dealerDataSlice.actions

export default dealerDataSlice.reducer
